<template>
    <DynamicSearchContainer />
</template>

<script>
import store from '@/store'
import DynamicSearchStore from '@/modules/DynamicSearch/_store'
import DynamicSearchContainer from '@/modules/DynamicSearch'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import useTagApiService from '@/composables/useTagApiService'
const STORE_KEY = '$_dynamicSearch'

export default {
    components: {
        DynamicSearchContainer
    },
    setup (props, context) {
        const {
            selectedProject,
            selectedGroup,
            setInitialAccountSelect
        } = useSelectProjectAndGroup()
        if (!selectedProject.value?.projectIdx && !selectedGroup.value?.groupIdx) {
            setInitialAccountSelect(true)
        }
        const { fetchTags } = useTagApiService()
        fetchTags()
    },
    beforeRouteEnter (to, from, next) {
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, DynamicSearchStore)
        }
        next()
    }
}
</script>

<style>

</style>
